var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000001_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 7.90323C9.849 7.90323 10.2667 8.30742 10.2667 8.80645C10.2667 9.30548 9.849 9.70968 9.33333 9.70968C8.81767 9.70968 8.4 9.30548 8.4 8.80645C8.4 8.30742 8.81767 7.90323 9.33333 7.90323ZM2.56667 14H11.6667C12.9547 14 14 12.9884 14 11.7419V5.87097C14 4.62452 12.9547 3.6129 11.6667 3.6129H10.7333V2.25806C10.7333 1.01161 9.688 0 8.4 0H2.8C1.253 0 0 1.21258 0 2.70968H0.0116667L0 11.5161C0 12.889 1.148 14 2.56667 14ZM2.83967 1.80645H8.4C8.65667 1.80645 8.86667 2.00968 8.86667 2.25806V3.6129H2.8C2.28433 3.61516 1.86433 3.21323 1.862 2.71419C1.862 2.68258 1.862 2.65323 1.86667 2.62161C1.92733 2.14968 2.34733 1.79742 2.83967 1.80645ZM1.86667 5.32226C2.09533 5.38548 2.32867 5.41935 2.56667 5.41935H11.6667C11.9233 5.41935 12.1333 5.62258 12.1333 5.87097V11.7419C12.1333 11.9903 11.9233 12.1935 11.6667 12.1935H2.56667C2.17933 12.1935 1.86667 11.891 1.86667 11.5161V5.32226Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000001_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBalance);
export default __webpack_public_path__ + "static/media/wallet-balance.f890185df8cfea7006e7cb92b48bca60.svg";
export { ForwardRef as ReactComponent };